import Flags from 'country-flag-icons/react/3x2'

export const languages = [
  { value: 'no', icon: Flags['NO'] },
  { value: 'en', icon: Flags['GB'] },
]
